import { FETCH_ERROR_FILE_SUCCESS, FETCH_ERROR_FILE_REQUEST, FETCH_ERROR_FILE_FAILURE, FETCH_ERROR_FILE_RESET, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const downloadErrorReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ERROR_FILE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_ERROR_FILE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_ERROR_FILE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_ERROR_FILE_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default downloadErrorReducer;
